import logo2010 from "../../assets/img/historicEvents/LogoExtremeRules/2010.png";
import logo2011 from "../../assets/img/historicEvents/LogoExtremeRules/2011.png";
import logo2012_2013 from "../../assets/img/historicEvents/LogoExtremeRules/2012-2013.png";
import logo2014 from "../../assets/img/historicEvents/LogoExtremeRules/2014.png";
import logo2015_2019 from "../../assets/img/historicEvents/LogoExtremeRules/2015-2019.png";
import logo2020 from "../../assets/img/historicEvents/LogoExtremeRules/2020.png";
import logo2021_2022 from "../../assets/img/historicEvents/LogoExtremeRules/2021-2022.png";

export const extremeRulesDetail = {
  "extreme-rules": {
    id: "extreme-rules",
    title: "Extreme Rules",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "extreme-rules",
        items: [
          {
            id: "extreme-rules-2010",
            title: "Extreme Rules",
            description: "2010",
            imgUrl: logo2010,
          },
          {
            id: "extreme-rules-2011",
            title: "Extreme Rules",
            description: "2011",
            imgUrl: logo2011,
          },
          {
            id: "extreme-rules-2012",
            title: "Extreme Rules",
            description: "2012 - 2013",
            imgUrl: logo2012_2013,
          },
          {
            id: "extreme-rules-2014",
            title: "Extreme Rules",
            description: "2014",
            imgUrl: logo2014,
          },
          {
            id: "extreme-rules-2015",
            title: "Extreme Rules",
            description: "2015",
            imgUrl: logo2015_2019,
          },
          {
            id: "extreme-rules-2016",
            title: "Extreme Rules",
            description: "There Are No Rules. Extreme Rules. 2016",
            imgUrl: logo2015_2019,
          },
          {
            id: "extreme-rules-2017",
            title: "Extreme Rules",
            description: "2017 - 2019",
            imgUrl: logo2015_2019,
          },
          {
            id: "extreme-rules-2020",
            title: "Extreme Rules",
            description: "The Horror Show at Extreme Rules 2020",
            imgUrl: logo2020,
          },
          {
            id: "extreme-rules-2021",
            title: "Extreme Rules",
            description: "2021 - 2022",
            imgUrl: logo2021_2022,
          },
        ],
      },
    ],
  },
};
